import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EnableTwoFAModal from './EnableTwoFAModal';
import NotVerifiedUserModal from './NotVerifiedUserModal';
import { closeModals, showModal } from '../../utils/helpers/actions';
import TwoFactorAuthModal from './TwoFactorAuthModal';
import QualificationRequiredModal from './QualificationRequiredModal';

const ModalWrapper = ({ modal, closeModals, showModal }) => {
  const onToggle = (name) => {
    if (modal.name) {
      closeModals();
    } else {
      showModal(name);
    }
  };

  switch (modal.name) {
    case 'EnableTwoFA':
      return (
        <EnableTwoFAModal
          onToggle={() => onToggle('EnableTwoFA')}
          isOpen={modal.name === 'EnableTwoFA'}
        />
      );
    case 'NotVerifiedUser':
      return (
        <NotVerifiedUserModal
          onToggle={() => onToggle('NotVerifiedUser')}
          isOpen={modal.name === 'NotVerifiedUser'}
        />
      );
    case 'LoginWithTFA':
      return (
        <TwoFactorAuthModal
          onToggle={() => onToggle('LoginWithTFA')}
          isOpen={modal.name === 'LoginWithTFA'}
        />
      );

    case 'QualificationRequired':
      return (
        <QualificationRequiredModal
          onToggle={() => onToggle('QualificationRequired')}
          isOpen={modal.name === 'QualificationRequired'}
        />
      );

    default:
      return '';
  }
};

ModalWrapper.propTypes = {
  modal: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  closeModals: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

const mapStateToProps = ({ helpers: { modal } }) => ({
  modal,
});

export default connect(mapStateToProps, {
  closeModals,
  showModal,
})(ModalWrapper);
